import { render, staticRenderFns } from "./chx.vue?vue&type=template&id=0b2aed32&scoped=true&"
import script from "./chx.vue?vue&type=script&lang=js&"
export * from "./chx.vue?vue&type=script&lang=js&"
import style0 from "./chx.vue?vue&type=style&index=0&id=0b2aed32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2aed32",
  null
  
)

export default component.exports